import { apiFetch } from './client';

export type DocumentStatus = 'pending' | 'indexing' | 'ready' | 'error';
export type DocumentKind = 'file' | 'url' | 'text';

export interface DocumentDto {
  id: string;
  name: string;
  kind: DocumentKind;
  status: DocumentStatus;
  error?: string | null;
  mimeType?: string | null;
  sourceUrl?: string | null;
  sourceText?: string | null;
  chunkCount: number;
  agentId?: string | null;
  projectId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentCreateResult extends DocumentDto {
  hasText?: boolean;
  note?: string | null;
}

const j = (d: unknown) => ({ body: JSON.stringify(d) });

export const documentsApi = {
  list: () => apiFetch<DocumentDto[]>('/api/documents'),

  addFile: (d: { name: string; mimeType?: string; data: string; agentId?: string | null; projectId?: string | null }) =>
    apiFetch<DocumentCreateResult>('/api/documents', { method: 'POST', ...j({ kind: 'file', ...d }) }),

  addUrl: (d: { url: string; name?: string; agentId?: string | null; projectId?: string | null }) =>
    apiFetch<DocumentCreateResult>('/api/documents', { method: 'POST', ...j({ kind: 'url', ...d }) }),

  addText: (d: { text: string; name?: string; agentId?: string | null; projectId?: string | null }) =>
    apiFetch<DocumentCreateResult>('/api/documents', { method: 'POST', ...j({ kind: 'text', ...d }) }),

  update: (id: string, d: {
    name?: string;
    agentId?: string | null;
    projectId?: string | null;
    url?: string;
    text?: string;
    mimeType?: string;
    data?: string;
  }) => apiFetch<DocumentDto>(`/api/documents/${id}`, { method: 'PATCH', ...j(d) }),

  reindex: (id: string) =>
    apiFetch<{ ok: boolean }>(`/api/documents/${id}/reindex`, { method: 'POST', body: '{}' }),

  remove: (id: string) =>
    apiFetch<{ ok: boolean }>(`/api/documents/${id}`, { method: 'DELETE' }),
};
